export const formPathname = `card-form`; // rely on mapping in FryingPan - https://fryingpan.wixpress.com/services/com.wixpress.payments-cc-form
// it shouldn't moved to utils/DataHook.ts since we don't need any other data-hooks in public component (to reduce bundle size)
export const formIframeDataHook = 'cc-form-public-frame';

export const timeouts = {
  maxReadyTimeout: 30 * 1000,
};

export const iframeId = 'payments-card-form-iframe';
export const iframeSelector = `iframe#${iframeId}`;
